import React, {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Container, Grid, Icon, List, Segment, Message} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';

const {getWtsCourseDocs, getWtsCourseDocFile, clearWtsCourseDocs} = Actions;

const WtsCourseDocuments = ({courseToEdit}) => {
  const dispatch = useDispatch();
  const courseId = courseToEdit?.course_id || courseToEdit?.idCursoReferencia || courseToEdit?.id;

  const {courseDocs, currentDocFile} = useSelector((state) => ({
    'courseDocs': state.wtsCourseDocuments?.courseDocuments?.data ||
      state.wtsCourseDocuments?.courseDocuments ||
      state.wtsCourseDocs?.list || [],
    'currentDocFile': state.wtsCourseDocuments?.currentDocFile || state.wtsCourseDocs?.currentDocFile,
  }));

  const processedDocRef = useRef(null);

  useEffect(() => {
    if (courseId) {
      dispatch(getWtsCourseDocs(courseId));
    }
    return () => {
      if (typeof clearWtsCourseDocs === 'function') {
        dispatch(clearWtsCourseDocs());
      }
    };
  }, [courseId, dispatch]);

  useEffect(() => {
    if (
      currentDocFile?.answers?.fileBase64 &&
      currentDocFile?._id !== processedDocRef.current
    ) {
      processedDocRef.current = currentDocFile?._id;
      const byteChars = atob(currentDocFile.answers.fileBase64);
      const byteArray = new Uint8Array([...byteChars].map((c) => c.charCodeAt(0)));
      const blob = new Blob([byteArray], {'type': 'application/pdf'});
      window.open(URL.createObjectURL(blob));
    }
  }, [currentDocFile]);

  const handleOpenDoc = (e, mongoId) => {
    e.preventDefault();
    processedDocRef.current = null;
    if (typeof getWtsCourseDocFile === 'function') {
      dispatch(getWtsCourseDocFile(mongoId));
    }
  };

  const finalDocs = Array.isArray(courseDocs) ? courseDocs.filter((doc) => {
    const docType = doc.doc_type || doc.tipo_documento || doc.type;
    return docType === 'FINAL_DOC_GESTOR' || docType === 'FINAL_DOC' || docType === 'OTHER';
  }) : [];

  return (
    <Card raised fluid style={{'boxShadow': 'none', 'border': 'none'}}>
      <Card.Content>
        <Message info icon>
          <Icon name="info circle" />
          <Message.Content>
            <b>Documentación Final del Curso</b>
            <p style={{'marginTop': '5px'}}>
              En esta sección se listan todos los documentos que han sido cargados
              previamente por el Gestor Dealer.
            </p>
          </Message.Content>
        </Message>

        <Grid columns={1} divided stackable style={{'marginTop': '10px'}}>
          <Grid.Column>
            <Segment
              padded
              style={{
                'height': '100%', 'backgroundColor': '#f9fafb',
                'border': '1px solid #e0e0e0', 'boxShadow': 'none',
              }}
            >
              <div
                style={{
                  'borderBottom': '1px solid #ddd',
                  'paddingBottom': '8px',
                  'marginBottom': '10px',
                  'display': 'flex',
                  'alignItems': 'center',
                  'color': '#2185d0',
                  'fontWeight': 'bold',
                  'fontSize': '1.1em',
                }}
              >
                <Icon name="folder open" style={{'marginRight': '8px'}} />
                <span>Archivos Cargados</span>
              </div>

              <Container fluid style={{'marginTop': '15px'}}>
                {finalDocs.length > 0 ? (
                  <List divided relaxed selection>
                    {finalDocs.map((doc, idx) => (
                      <List.Item
                        key={doc.id || doc._id || doc.mongo_id || idx}
                        onClick={(e) => handleOpenDoc(e, doc.mongo_id || doc.id_mongo)}
                        style={{'padding': '10px 5px', 'display': 'flex', 'alignItems': 'center'}}
                      >
                        <Icon
                          name="file pdf outline"
                          color="red"
                          size="large"
                          style={{'marginRight': '10px'}}
                        />
                        <List.Content>
                          <span
                            style={{
                              'color': '#2185d0',
                              'cursor': 'pointer',
                              'fontWeight': '500',
                            }}
                          >
                            {doc.file_name || doc.nombre_archivo || 'Documento PDF'}
                          </span>
                          {doc.description && (
                            <div style={{'fontSize': '0.9em', 'color': '#666', 'marginTop': '2px'}}>
                              {doc.description}
                            </div>
                          )}
                          {(doc.user || doc.usuario_creacion) && (
                            <div style={{'fontSize': '0.8em', 'color': '#888'}}>
                              Subido por: {doc.user || doc.usuario_creacion}
                            </div>
                          )}
                        </List.Content>
                      </List.Item>
                    ))}
                  </List>
                ) : (
                  <div style={{'textAlign': 'center', 'color': 'grey', 'padding': '20px 0'}}>
                    <Icon name="info circle" size="large" style={{'marginBottom': '10px'}} />
                    <p>No se han encontrado documentos finales cargados.</p>
                  </div>
                )}
              </Container>
            </Segment>
          </Grid.Column>
        </Grid>
      </Card.Content>
    </Card>
  );
};

export default WtsCourseDocuments;
